import { create } from "zustand";

interface UtilsState {
  isLoading: boolean;
  setLoading: (status: boolean) => void;
}

export const useUtilsStore = create<UtilsState>((set) => ({
  isLoading: false,
  setLoading: (status) => set({ isLoading: status }),
}));
